const KEY = "fs_driver_token";

export const getDriverToken = () => localStorage.getItem(KEY);
export const setDriverToken = (t) => localStorage.setItem(KEY, t);
export const clearDriverToken = () => localStorage.removeItem(KEY);
export const onDriverRoute = () => window.location.pathname.startsWith("/driver");
